module.exports = __webpack_public_path__ + "img/Detection_Line_2_20px_Icon.8b16634a.svg";